/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../graphql-types.gen';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type RetailersQueryVariables = Exact<{ [key: string]: never; }>;


export type RetailersQuery = { retailers: { items: Array<{ icon: string | null | undefined, id: number, name: string | null | undefined, url: string | null | undefined } | null | undefined> } | null | undefined };

export declare const Retailers: import("graphql").DocumentNode;
export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const RetailersDocument = new TypedDocumentString(`
    query Retailers {
  retailers(currentPage: 1, pageSize: 24) {
    items {
      icon
      id
      name
      url
    }
  }
}
    `) as unknown as TypedDocumentString<RetailersQuery, RetailersQueryVariables>;